import { EquatableKeyStackItem } from './EquatableKeyStackItem';
export class BlockStackItem extends EquatableKeyStackItem {
    asBlock() {
        return this.value;
    }
    asHeader() {
        return this.value.header;
    }
    asBlockBase() {
        return this.value;
    }
}

//# sourceMappingURL=BlockStackItem.js.map
